<script lang="ts" setup>
export interface PagesOfficesDetailNavLink {
    latitude: string
    longitude: string
    title?: string
}

const props = defineProps<PagesOfficesDetailNavLink>()
const { data, sendEvent } = useTracker()
const { $t } = useNuxtApp()

const eventTitle = $t('Navigovať')

const handleClick = (): void => {
    sendEvent({
        data: {
            ...data,
            title: props.title as string,
            click: eventTitle,
        },
    })
}
</script>
<template>
  <div>
    <a
      :href="`https://www.google.sk/maps/place/${props.latitude},${props.longitude}`"
      target="_blank"
      class="d-inline-flex align-items-center fw-bolder fs-smaller text-decoration-underline"
      @click="handleClick"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        class="d-block me-2 text-secondary"
      >
        <path
          d="M11.587 4.413 3.109 8.326h4.565v4.565l3.913-8.478zM8 1.153A6.843 6.843 0 0 1 14.848 8 6.842 6.842 0 0 1 8 14.848 6.842 6.842 0 0 1 1.152 8 6.843 6.843 0 0 1 8 1.153zM8 .5A7.505 7.505 0 0 0 .5 8c0 4.138 3.362 7.5 7.5 7.5s7.5-3.362 7.5-7.5S12.138.5 8 .5z"
        />
      </svg>
      {{ eventTitle }}
    </a>
  </div>
</template>
